import { isCnpj, normalizeCpfCnpj } from '~/utils/cnpj'

export const CpfCnpjMask = (value: string) => {
  if (!value) return '-'

  const raw = normalizeCpfCnpj(value)

  if (!isCnpj(raw)) {
    return `${raw.slice(0, 3)}.${raw.slice(3, 6)}.${raw.slice(6, 9)}-${raw.slice(9, 11)}`
  }

  return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(
    12,
    14,
  )}`
}

export const FormatPhone = (value: string) => {
  if (!value) return '-'

  return value
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/g, '($1)$2')
    .replace(/(\d)(\d{4})(\d)/g, ' $1$2-$3')
}

export const FormatPhoneWithCountry = (pais_celular: string, celular: string) => {
  pais_celular = pais_celular ?? '55'
  celular = celular ?? '-'

  if (pais_celular.length === 2)
    return `+${pais_celular} ${celular
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/g, '($1)$2')
      .replace(/(\d)(\d{4})(\d)/g, ' $1$2-$3')}`

  return `+${pais_celular} ${celular.replace(/\D/g, '').replace(/^(\d{3})(\d)/g, '$1 $2')}`
}

export const FormatCep = (value: String) => {
  if (!value) return '-'

  return value.replace(/\D/g, '').replace(/^(\d{5})(\d)/g, '$1-$2')
}

export const removeCountryOfPhone = (value: string, pais_celular?: string) => {
  if (!value) return '-'

  pais_celular = pais_celular ?? '55'
  let phone = value.replace(`+${pais_celular}`, '')
  phone = phone.replace(/\D/g, '')
  return phone
}
